import { Component, inject } from '@angular/core';
import { OffcanvasService } from '../../../../../_services/offcanvas-service/offcanvas.service';
import { BoFormsModule } from '@bo/ng-forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SubmitComponent } from '../../../../../shared/components/forms/submit/submit.component';
import { AppFormComponent } from '../../../../../shared/classes/app-form';
import { PasswordChange, PasswordResponse } from '../../../../../_interfaces/password-interface';
import { PasswordResetService } from '../../../../../_services/password-reset/password-reset.service';
import { Method } from '@bo/ng-api';
import { Observable } from 'rxjs';
import { PasswordFieldComponent } from '../../../../../shared/components/forms/password-field/password-field.component';
import { ToastService } from '../../../../../_services/toast-service/toast.service';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { HttpParams } from '@angular/common/http';
import { OffcanvasCancelBtnComponent } from '../../../../../shared/components/offcanvas/offcanvas-cancel-btn/offcanvas-cancel-btn.component';
import { LoaderComponent } from '../../../../../shared/components/loader/loader.component';
import { OffcanvasBaseComponent } from '../../../../../shared/components/offcanvas/offcanvas-base/offcanvas-base.component';

@Component({
  selector: 'app-password-change',
  imports: [
    BoFormsModule,
    ReactiveFormsModule,
    SubmitComponent,
    PasswordFieldComponent,
    OffcanvasCancelBtnComponent,
    LoaderComponent,
    OffcanvasBaseComponent,
  ],
  providers: [NgbActiveOffcanvas],
  templateUrl: './password-change.component.html',
})
export class PasswordChangeComponent extends AppFormComponent<PasswordResponse> {
  readonly offcanvasService = inject(OffcanvasService);
  readonly passwordResetService = inject(PasswordResetService);
  readonly toastService = inject(ToastService);

  protected returnUrl: string = '/settings';
  readonly returnParams = new HttpParams().append('page', 'profile');

  protected fields: string[] = ['current_password', 'new_password', 'confirm_password'];

  createForm(): void {
    this.buildFromOptions(
      this.passwordResetService.getOptions(this.passwordResetService.URL_PASSWORD_CHANGE, Method.POST, true),
    ).subscribe();
  }

  submitData(formData: PasswordChange): Observable<PasswordResponse> {
    return this.passwordResetService.changePassword(formData);
  }

  handleSubmitSuccess(): void {
    this.toastService.show(`Your password has been updated.`, 'iconoir-check-circle');
    this.offcanvasService.close(this.returnUrl, this.returnParams);
  }

  showHelpText(field: string): boolean {
    const formErrors = this.form.controls[field].errors;
    if (formErrors == null) return true;
    else return formErrors['server'] == undefined;
  }
}
